import React from 'react';
import { Routes, Route } from 'react-router-dom';

import { AgentListPage } from './list';
import { AgentViewPage } from './dashboard';

export const AgentsModule = () => {
  return (
    <Routes>
      <Route path=":id/*" element={<AgentViewPage />} />
      <Route path="/" element={<AgentListPage />} />
    </Routes>
  );
};
